import { useAtomValue } from 'jotai';
import { ROUTES } from '../../constants/RouteNameMapping';
import { toURLFriendlyStringWithDashes } from '../../util/url-utils';
import { companyStateJ } from '../../services/state/CompanyStateJ';
import { selectedCompanyIdProfileAtom } from './state/UIStateJ';

export function useProfileBasePath() {
  const companyId = useAtomValue(selectedCompanyIdProfileAtom);
  const company = useAtomValue(companyStateJ(companyId ?? -1));
  const urlFriendly = toURLFriendlyStringWithDashes(`${company?.name}-${companyId}`);
  return `/${ROUTES.COMPANY_PROFILES}/${urlFriendly}`;
}
